import React from 'react';
import useGetPacsConfer from './Hooks/useGetPacsConfer';
import {
  Alert,
  Container,
  LinearProgress,
} from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import PacsList from './Components/PacsList';
import { useLocation } from 'react-router-dom';
import { hwndjs } from 'utils/hwnd';
import i18next from 'i18next';

const PacsImages = () => {
  const location = useLocation();
  const queryString = location.search;
  const queryStringWithoutQuestionMark =
    queryString.slice(1);

  const pacsConfer = useGetPacsConfer(
    hwndjs(queryStringWithoutQuestionMark, true)
  );
  const alertLabel = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  console.log('pacsConfer--->',pacsConfer)
 
  return (
    <React.Fragment>
      <Container sx={{ pt: '1em' }}>
        {pacsConfer && pacsConfer?.length > 0 ? (
          <PacsList pacsConfer={pacsConfer} />
        ) : pacsConfer?.length === 0 ? (
          <Alert
            dir={i18next.language === 'en' ? 'ltr' : 'rtl'}
            severity="info"
            sx={{
              mt: '1em',
              width: '100%',
            }}
          >
            {alertLabel}
          </Alert>
        ) : (
          <LinearProgress />
        )}
      </Container>
    </React.Fragment>
  );
};

export default PacsImages;
